export default __webpack_public_path__ + "media/components/Pages/Abitur/Foreigners-3d8e5b5657cb60f197726b610a042608.jpg";